<template>
    <Component :is="variationComponents[slice.variation as keyof typeof variationComponents]" v-bind="props" />
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {TagsSlice} from '@prismicio-types';
    import TagsDefault from './variations/TagsDefault.vue';

    const props = defineProps(getSliceComponentProps<TagsSlice>());

    const variationComponents = {
        default: TagsDefault,
    };
</script>
